/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Selectsavedfilter2Inputs */

const en_common_selectsavedfilter2 = /** @type {(inputs: Common_Selectsavedfilter2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a saved filter`)
};

/**
* | output |
* | --- |
* | "Select a saved filter" |
*
* @param {Common_Selectsavedfilter2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_selectsavedfilter2 = /** @type {((inputs?: Common_Selectsavedfilter2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Selectsavedfilter2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_selectsavedfilter2(inputs)
});
export { common_selectsavedfilter2 as "common_selectSavedFilter" }